import { render, staticRenderFns } from "./NotificationCenterDetails.vue?vue&type=template&id=1d7134fc&scoped=true&"
import script from "./NotificationCenterDetails.vue?vue&type=script&lang=js&"
export * from "./NotificationCenterDetails.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCenterDetails.vue?vue&type=style&index=0&id=1d7134fc&prod&lang=scss&scoped=true&"
import style1 from "./NotificationCenterDetails.vue?vue&type=style&index=1&id=1d7134fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7134fc",
  null
  
)

export default component.exports